module.exports = __webpack_public_path__ + "img/certified-doctors-mirror.d6eef7f2.jpg";